import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Link } from '@material-ui/core';
import TrendingFlatIcon from '@material-ui/icons/TrendingFlat';

// COMPONENTS
import RouterLink from '@/components/Link';
import Image from '@/components/Image';

// STYLES
import FeatureCardStyled from './styles';

function FeatureCard({ data, analyticsLocation }) {
  return (
    <FeatureCardStyled className="feature-card">
      <Image
        className="feature-card__img"
        src={data.img.src}
        srcSet={data.img.srcSet}
        alt={data.title}
      />
      <Typography variant="h5" className="feature-card__title">
        {data.title}
      </Typography>
      <Typography className="feature-card__desc p3">{data.desc}</Typography>
      <Link
        component={RouterLink}
        className="feature-card__link"
        color="textPrimary"
        to={data.link.href}
        location={analyticsLocation}
      >
        {data.link.title}
        <TrendingFlatIcon />
      </Link>
    </FeatureCardStyled>
  );
}

FeatureCard.propTypes = {
  data: PropTypes.object.isRequired,
  analyticsLocation: PropTypes.string,
};

export default FeatureCard;
